module.exports = __webpack_public_path__ + "img/stamp-reset.0537222a.png";